import { jsx as _jsx } from "react/jsx-runtime";
import ResizeTextarea from 'react-textarea-autosize';
import { forwardRef, Textarea as ChakraTextarea, useStyleConfig, } from '@chakra-ui/react';
import { omit } from '@chakra-ui/utils';
export const Textarea = forwardRef(({ minAutosizeRows = 3, maxAutosizeRows = 6, ...props }, ref) => {
    const inputStyles = useStyleConfig('Textarea', props);
    // Omit extra props so they will not be passed into the DOM and trigger
    // React warnings.
    const inputProps = omit(props, ['isSuccess', 'isPrefilled']);
    return (_jsx(ChakraTextarea
    //Chakra sets a default minH which prevents autosize to control starting height.
    // Set here instead of on the theme to prevent all base text areas from having no minH.
    , { 
        //Chakra sets a default minH which prevents autosize to control starting height.
        // Set here instead of on the theme to prevent all base text areas from having no minH.
        minH: "unset", ref: ref, as: ResizeTextarea, minRows: minAutosizeRows, maxRows: maxAutosizeRows, sx: inputStyles, ...inputProps }));
});
Textarea.displayName = 'Textarea';
